<template>
    <a-row class="vh-100 asd" type="flex" align="middle" justify="center">
        <a-col :xs="24" :sm="24" :md="6" :lg="6">
            <a-card>
                <a-form class="login-form" @submit.prevent="login(user)">

                    <img src="/logo.png" alt="main logo" style="width:100%; padding: 25px;">

                    <a-form-item
                        :has-feedback="true"
                        label="ID de Cliente o eMail"
                        :validate-status="hasError('username') ? 'error' : ''"
                        :help="getError('username')">

                        <a-input
                            id="username"
                            v-model="user.username"
                            placeholder="ID de Cliente o eMail"
                            @keyup="removeError('username')">
                            <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
                        </a-input>
                    </a-form-item>

                    <a-form-item
                        :has-feedback="true"
                        :label="lang.login.password_label"
                        :validate-status="hasError('password') ? 'error' : ''"
                        :help="getError('password')">

                        <a-input-password
                            id="password"
                            v-model="user.password"
                            :type="showPassword ? 'text' : 'password'"
                            :placeholder="lang.login.password_placeholder"
                            @keyup="removeError('password')">
                            <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
                        </a-input-password>
                    </a-form-item>

                    <a-form-item class="text-center">
                        <router-link to="/recover" class="login-form-forgot">
                            {{ lang.login.password_recover }}
                        </router-link>
                        <a-button
                            type="primary"
                            html-type="submit"
                            :loading="isLoading"
                            class="login-form-button"
                            block>
                                {{ lang.login.login_button }}
                        </a-button>
                    </a-form-item>

                </a-form>
            </a-card>
        </a-col>
    </a-row>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
    data: () => ({
        user: {
            username: '',
            password: '',
            rememberMe: true,
        },
        showPassword: false
    }),
    computed: {
        ...mapGetters({
            lang: 'lang',
            hasError: 'hasError',
            getError: 'getError'
        }),
        ...mapState({
            isLoading: state => state.session.isLoading
        })
    },
    methods: {
        ...mapActions({
            removeError: 'removeError',
            login: 'session/login'
        }),
    },
}
</script>
